export default __webpack_public_path__ + "static/media/favicon.ef8c73bb.png";